import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface SiteLayoutProps {
  children: React.ReactNode;
}
/**
 * Checkout runs as a focused, chrome-free surface: no site nav, no footer.
 * Every other route gets the full site chrome.
 */
const BARE_ROUTES = ['/checkout'];
export function SiteLayout({
  children
}: SiteLayoutProps) {
  const location = useLocation();
  const isBare = BARE_ROUTES.includes(location.pathname);
  if (isBare) {
    return <main className="min-h-screen bg-black" data-id="element-121" data-mp="3iu480ezalu2x">{children}</main>;
  }
  return <>
      <Navbar data-id="element-122" data-mp="3nlck5is0btjs" />
      <main data-id="element-123" data-mp="3nmxdx66hz8gl">{children}</main>
      <Footer data-id="element-124" data-mp="3nmnuy2jve1ke" />
    </>;
}